import React, { useMemo } from "react";
import "./tokenInput.css";

const RE_DIGIT = new RegExp(/^\d+$/);

export default function TokenInput({ token, setToken }) {
  const valueItems = useMemo(() => {
    const valueArray = token.split("");
    const items = [];

    for (let i = 0; i < 6; i++) {
      const char = valueArray[i];

      if (RE_DIGIT.test(char)) {
        items.push(char);
      } else {
        items.push("");
      }
    }

    return items;
  }, [token]);

  const focusToNextInput = (target) => {
    const nextElementSibling = target.nextElementSibling;

    if (nextElementSibling) {
      nextElementSibling.focus();
    }
  };
  const focusToPrevInput = (target) => {
    const previousElementSibling = target.previousElementSibling;

    if (previousElementSibling) {
      previousElementSibling.focus();
    }
  };

  const inputOnChange = (e, idx) => {
    const target = e.target;
    let targetValue = target.value.trim();
    const isTargetValueDigit = RE_DIGIT.test(targetValue);

    if (!isTargetValueDigit && targetValue !== "") {
      return;
    }

    targetValue = isTargetValueDigit ? targetValue : " ";

    const targetValueLength = targetValue.length;

    if (targetValueLength === 1) {
      const newValue =
        token.substring(0, idx) + targetValue + token.substring(idx + 1);

      if (!isTargetValueDigit) {
        return;
      }

      focusToNextInput(target);
      setToken(newValue);

      if (!isTargetValueDigit && targetValue !== "") {
        return;
      }

      const nextInputEl = target.nextElementSibling;

      // only delete digit if next input element has no value
      if (!isTargetValueDigit && nextInputEl && nextInputEl.value !== "") {
        return;
      }

      targetValue = isTargetValueDigit ? targetValue : " ";

      const nextElementSibling = target.nextElementSibling;

      if (nextElementSibling) {
        nextElementSibling.focus();
      }
    } else if (targetValueLength === 6) {
      setToken(targetValue);

      target.blur();
    }
  };

  const inputOnKeyDown = (e) => {
    const { key } = e;
    const target = e.target;

    if (key === "ArrowRight" || key === "ArrowDown") {
      e.preventDefault();
      return focusToNextInput(target);
    }

    if (key === "ArrowLeft" || key === "ArrowUp") {
      e.preventDefault();
      return focusToPrevInput(target);
    }

    const targetValue = target.value;

    // keep the selection range position
    // if the same digit was typed
    target.setSelectionRange(0, targetValue.length);

    if (e.key !== "Backspace" || targetValue !== "") {
      return;
    }

    focusToPrevInput(target);
  };

  const inputOnFocus = (e) => {
    const { target } = e;

    // keep focusing back until previous input
    // element has value
    const prevInputEl = target.previousElementSibling;

    if (prevInputEl && prevInputEl.value === "") {
      return prevInputEl.focus();
    }

    target.setSelectionRange(0, target.value.length);
  };

  return (
    <div className="token-input-fields">
      {valueItems.map((val, idx) => (
        <input
          key={idx}
          maxLength={6}
          inputMode="numeric"
          autoComplete="one-time-code"
          pattern="\d{1}"
          className="token-inputs"
          type="text"
          onChange={(e) => inputOnChange(e, idx)}
          value={val}
          onKeyDown={inputOnKeyDown}
          onFocus={inputOnFocus}
        />
      ))}
    </div>
  );
}
